export const logo = process.env.REACT_APP_THEME_LOGO;
export const icon = process.env.REACT_APP_THEME_ICON;

export default logo;
